// Spark / CORE - на каждой странице: live search, мега-меню, company,
// меню аккаунта (nav-account/logout), мобильная панель, корзина-drawer.
// Панели шапки взаимоисключающие: открытие любой закрывает остальные
// через closeNavPanels - меню не живут одновременно.
// Клики - ЕДИНЫЙ делегатор по data-action (inline onclick вычищен
// из разметки: вебпак-бандл живёт в module scope, глобальных нет).
// Запросы - через плагин http (axios: baseURL /ajax, X-Requested-With,
// таймаут - всё из коробки, ControllerBaseAjax пропускает).

import { axios } from './plugins/http';
import './img-fallback';
import './includes/newsletter';

// ===== закрывалка панелей шапки =====
// except - ключ панели, которую НЕ трогаем (она сейчас открывается
// своим toggle): 'mega' | 'co' | 'account' | 'search' | 'mobile'
function closeNavPanels( except ) {

    if( except !== 'mega' ) {

        const menu = document.getElementById('megaMenu');

        if( menu && menu.classList.contains('open') ) {
            menu.classList.remove('open');
            document.getElementById('megaOverlay')?.classList.remove('open');
        }
    }

    if( except !== 'co' )
        document.getElementById('navCo')?.classList.remove('open');

    if( except !== 'account' )
        document.getElementById('navAccount')?.classList.remove('open');

    if( except !== 'search' )
        closeSearchDD();

    if( except !== 'mobile' )
        document.getElementById('mobilePanel')?.classList.remove('open');
}

// ===== единая отслеживалка кликов =====
document.addEventListener('click', (e) => {

    const btn    = e.target.closest('[data-action]');
    const action = btn ? btn.dataset.action : null;

    // клики мимо открытых панелей - закрытие всего, кроме панели,
    // внутри которой кликнули (мега закрывается и отсюда, и оверлеем -
    // повторный remove безвреден)
    if( ! action ) {

        if( ! e.target.closest('.nav-search') )
            closeSearchDD();

        if( ! e.target.closest('#megaMenu') ) {

            const menu = document.getElementById('megaMenu');

            if( menu && menu.classList.contains('open') ) {
                menu.classList.remove('open');
                document.getElementById('megaOverlay')?.classList.remove('open');
            }
        }

        const co = document.getElementById('navCo');
        if( co && co.classList.contains('open') && ! e.target.closest('#navCo') )
            co.classList.remove('open');

        const account = document.getElementById('navAccount');
        if( account && account.classList.contains('open') && ! e.target.closest('#navAccount') )
            account.classList.remove('open');

        return;
    }

    switch( action ) {

        case 'mega':
            closeNavPanels('mega');
            toggleMega();
            break;

        case 'nav-co':
            closeNavPanels('co');
            document.getElementById('navCo')?.classList.toggle('open');
            break;

        case 'nav-account':
            closeNavPanels('account');
            document.getElementById('navAccount')?.classList.toggle('open');
            break;

        case 'logout':
            // снос JWT-куки на бэке (ajax auth/logout) и перезагрузка -
            // страница отрендерится гостевой; ошибку глотаем (кука
            // протухла сама - тот же результат)
            e.preventDefault();
            axios.post('/auth/logout')
                .catch( () => {} )
                .finally( () => location.reload() );
            break;

        case 'mobile-menu':
            closeNavPanels('mobile');
            document.getElementById('mobilePanel')?.classList.toggle('open');
            break;

        case 'mobile-cats':
            closeNavPanels('mega');
            toggleMega();
            break;

        case 'search-open':
            // лупа шапки (<=768): поиск на всю шапку
            closeNavPanels('search');
            document.getElementById('mainNav')?.classList.add('msearch-open');
            document.getElementById('searchInput')?.focus();
            break;

        case 'search-close':
            closeSearchDD();
            document.getElementById('mainNav')?.classList.remove('msearch-open');
            break;

        case 'cart':
            // корзина-drawer - подключится ajax-заходом (CacheCart)
            document.getElementById('cartDrawer')?.classList.toggle('open');
            break;
    }
});

// ===== мега-меню категорий: ajax при первом открытии, JS-память =====
let _megaLoaded = false;

function toggleMega() {

    const menu    = document.getElementById('megaMenu');
    const overlay = document.getElementById('megaOverlay');

    if( ! menu )
        return;

    const opening = ! menu.classList.contains('open');

    menu.classList.toggle( 'open', opening );

    if( overlay )
        overlay.classList.toggle( 'open', opening );

    if( opening && ! _megaLoaded )
        loadMegaCategories();
}

function loadMegaCategories() {

    axios.get('/menu/categories')
        .then( ({ data }) => {

            const cats = ( data && data.data && data.data.menu ) || [];
            const grid = document.getElementById('megaMenuGrid');

            if( ! grid )
                return;

            if( ! cats.length ) {
                grid.innerHTML = '<div class="mega-empty">Categories are coming soon.</div>';
                _megaLoaded = true;
                return;
            }

            // Рендер 1:1 с шаблоном all_categories.html (buildMegaMenu):
            // раскладка round-robin cols[i%4] (читается по строкам),
            // divider ПЕРЕД блоком кроме первого; отличие от шаблона
            // одно - head у нас ссылка на категорию, не div.
            // Контракт MenuController: корни С children.
            const columns = [ [], [], [], [] ];

            cats.forEach( ( c, i ) => columns[ i % 4 ].push( c ) );

            const catLink = ( c ) => window.baseURL + '/category/' + c.slug;

            const catBlock = ( c, first ) =>
                ( first ? '' : '<div class="mega-cat-divider"></div>' )
                + '<a class="mega-cat-head" href="' + catLink( c ) + '">'
                + '<span class="mega-cat-title">' + c.name + '</span></a>'
                + ( c.children || [] ).map( ch =>
                    '<a class="mega-sub-link" href="' + catLink( ch ) + '">' + ch.name + '</a>'
                ).join('');

            grid.innerHTML = columns.filter( col => col.length ).map( col =>
                '<div class="mega-col">'
                + col.map( ( c, i ) => catBlock( c, i === 0 ) ).join('')
                + '</div>'
            ).join('');

            _megaLoaded = true;
        })
        .catch( () => {} );
}

// оверлей мега-меню закрывает его же
document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('megaOverlay')?.addEventListener( 'click', toggleMega );
});

// ===== live search =====
function closeSearchDD() {
    document.getElementById('searchDD')?.classList.remove('open');
}

document.addEventListener('DOMContentLoaded', () => {

    const input    = document.getElementById('searchInput');
    const dd       = document.getElementById('searchDD');
    const clearBtn = document.getElementById('searchClear');

    if( ! input || ! dd )
        return;

    let timer = null, lastQ = '';

    // Крестик очистки: виден только при заполненном поле (значение
    // могло приехать и с сервера - страница /products?search=...)
    function toggleClear() {

        if( clearBtn )
            clearBtn.hidden = input.value === '';
    }

    toggleClear();

    clearBtn?.addEventListener( 'click', () => {

        input.value = '';
        lastQ       = '';

        clearTimeout( timer );
        closeSearchDD();
        toggleClear();
        input.focus();
    } );

    const money = ( cents ) => '$' + ( cents / 100 ).toFixed(2);

    function render( items, q, total ) {

        if( ! items.length ) {
            dd.innerHTML = '<div class="search-dd-empty">'
                + '<div class="search-dd-empty-ico">&#128269;</div>'
                + '<div class="search-dd-empty-t">No results for "' + q.replace( /</g, '&lt;' ) + '"</div>'
                + '<div class="search-dd-empty-s">Try another word</div></div>';
        } else {
            dd.innerHTML = items.map( p => {

                const price = p.sale_price > 0 ? p.sale_price : p.price;
                const old   = p.sale_price > 0 && p.sale_price < p.price
                    ? '<span class="search-dd-price-old">' + money( p.price ) + '</span>' : '';
                const img   = p.image_thumb
                    ? '<img src="' + p.image_thumb + '" alt="" loading="lazy">' : '';

                return '<a class="search-dd-item"'
                    + ' href="' + window.baseURL + '/' + p.slug + '">'
                    + '<div class="search-dd-thumb">' + img + '</div>'
                    + '<div class="search-dd-info"><div class="search-dd-name">' + p.title + '</div></div>'
                    + '<div class="search-dd-prices"><span class="search-dd-price">' + money( price ) + '</span>' + old + '</div>'
                    + '</a>';
            }).join('');

            // футер: сколько показано из найденного + переход на всю выдачу
            const count = total > items.length
                ? '<b>' + items.length + '</b> of <b>' + total + '</b> results'
                : '<b>' + items.length + '</b> ' + ( items.length === 1 ? 'result' : 'results' );

            dd.innerHTML += '<div class="search-dd-foot">'
                + '<span class="search-dd-count">' + count + '</span>'
                + '<a class="search-dd-all" href="' + window.baseURL + '/products?search=' + encodeURIComponent( q ) + '">View all'
                + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
                + '</a></div>';
        }

        dd.classList.add('open');
    }

    input.addEventListener('input', () => {

        toggleClear();

        const q = input.value.trim();

        clearTimeout( timer );

        if( q.length < 2 ) {
            closeSearchDD();
            lastQ = '';
            return;
        }

        // набор в поиске = открытие панели саджеста - меню закрываем
        closeNavPanels('search');

        timer = setTimeout( () => {

            if( q === lastQ )
                return;

            lastQ = q;

            axios.get( '/search', { params: { query: q } } )
                .then( ({ data }) => {
                    if( data && data.data && data.data.items )
                        render( data.data.items, q, Number( data.data.total ) || 0 );
                })
                .catch( () => {} );
        }, 250 );
    });
});